import React, {useEffect, useRef, useState} from 'react';

import {getCookie} from '../../../api/cookie';

import {Box, IconButton, Typography} from '@mui/material';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';

import MenuBox from '../common/MenuBox';

export default function Footer({ isMiddleSideBar }) {
    const menuBoxRef = useRef(null);

    const username = getCookie('username');

    const [isOpenMenuBox, setIsOpenMenuBox] = useState(false);

    const handleToggleMenuBox = () => {
        setIsOpenMenuBox(!isOpenMenuBox);
    };

    useEffect(() => {
        if (!isOpenMenuBox) return;

        const handleClickOutside = (e) => {
            if (menuBoxRef.current && !menuBoxRef.current.contains(e.target)) {
                setIsOpenMenuBox(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpenMenuBox]);

    return (
        <Box
            ref={menuBoxRef}
            sx={{
                width: '100%',
                height: '48px',
                pl: isMiddleSideBar ? '20px' : '8px',
                pr: '8px',
                boxSizing: 'border-box',
                display: 'flex',
                alignItems: 'center',
                justifyContent: isMiddleSideBar ? 'space-between' : 'center',
                borderTop: 1,
                borderColor: 'grey.300',
                position: 'relative',
            }}
        >
            {isMiddleSideBar
                ? <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ minWidth: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Typography variant='subtitle2' noWrap>{username}</Typography>
                        <Typography variant='subtitle2'>님</Typography>
                    </Box>
                    <IconButton size='small' color='default' onClick={handleToggleMenuBox}>
                        <KeyboardArrowRightRoundedIcon />
                    </IconButton>
                </Box>
                : <IconButton size='small' color='default' onClick={handleToggleMenuBox}>
                    <KeyboardArrowRightRoundedIcon />
                </IconButton>
            }
            {isOpenMenuBox && <MenuBox />}
        </Box>
    );
}
